export default {
  assertFavoriteIsSet(item) {
    if (item && item._userState && !item._userState.favorite) item._userState.favorite = 0;
  },
  markAsFavorite(item) {
    let moduleId = item._moduleId;
    console.debug('3. markAsFavorite / manage localStorage');
    //item._userState = Object.assign(item._userState, { favorite: 1 });

    setItemFavoriteStateIntoLocalStorage(moduleId, item.id, 1);
  },
  removeFromFavorites(item) {
    let moduleId = item._moduleId;
    console.debug('3. removeFromFavorite / manage localStorage');
    //item._userState = Object.assign(item._userState, { favorite: 0 });

    removeFavoriteStateFromLocalStorage(moduleId, item.id);
  },
  toggleFavorite(item) {
    if (this.isFavorite(item)) {
      this.removeFromFavorites(item);
    } else {
      this.markAsFavorite(item);
    }
  },
  isFavorite(item) {
    return item && item._userState && item._userState.favorite === 1;
  },
  addFavoriteStatesFromLocalStorage({ moduleId, items }) {
    let moduleStates = getFavoriteModuleStates(moduleId);
    items.forEach((d) => {
      try {
        d._userState.favorite = moduleStates[d.id] ? moduleStates[d.id] : 0;
      } catch (e) {
        console.warn(`not possible to set favorite on ${moduleId} for item ${d.title}`);
      }
    });
  },
};

function getFavoriteModuleStates(moduleId) {
  let favorites = JSON.parse(localStorage.getItem('favorites') || '{}');
  if (!favorites[moduleId]) favorites[moduleId] = {};
  return favorites[moduleId];
}

function setItemFavoriteStateIntoLocalStorage(moduleId, itemId, value) {
  let favorites = JSON.parse(localStorage.getItem('favorites') || '{}');
  if (!favorites[moduleId]) favorites[moduleId] = {};
  let moduleFavorites = favorites[moduleId];
  moduleFavorites[itemId] = value;
  console.debug('update localStorage as', JSON.stringify(favorites, null, 2));
  localStorage.setItem('favorites', JSON.stringify(favorites));
}
function removeFavoriteStateFromLocalStorage(moduleId, itemId) {
  let favorites = JSON.parse(localStorage.getItem('favorites') || '{}');
  if (!favorites[moduleId]) favorites[moduleId] = {};
  let moduleFavorites = favorites[moduleId];
  delete moduleFavorites[itemId];
  console.debug('update localStorage as', JSON.stringify(favorites, null, 2));
  localStorage.setItem('favorites', JSON.stringify(favorites));
}
